export default "__VITE_ASSET__ecd34ecf__"